export class AreaEtimeModel {
  public cdc: string;
  public notes: string;
}
